// TEMP: Club Font doesn't include accented character glyphs — strip diacritics from server-rendered collection card names to avoid browser falling back to a system font. Remove once font file is updated to support accented characters.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.uzkb_preview_personalise_container #uzkb_preview_personalise_name_text').forEach(function (el) {
    var textNode = el.querySelector('textPath') || el;
    textNode.textContent = textNode.textContent.normalize('NFD').replace(/[̀-ͯ]/g, '');
  });
});

jQuery(document).ready(function () {

  if (!document.body.classList.contains('product-auction-pro-template')) return;

  // Format product page h1 title
  jQuery('.product__title h1, h1.product__title').each(function () {
    var html = jQuery(this).html();
    html = html.replace(/(Signed|Unsigned)\s/g, '<span class="marked">$1 ');
    html = html.replace(/\s(Shirt|Ball)/g, ' $1</span>');
    html = html.replace(/\s-\s/g, ' ');
    jQuery(this).html(html);
  });
  jQuery('.product__title h1, h1.product__title').each(function (i, v) {
    jQuery(v).contents().eq(2).wrap('<span>');
  });

});